import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Checkbox } from "primereact/checkbox";
import { confirmDialog } from "primereact/confirmdialog";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/saga-blue/theme.css";
import { useToast } from "../other/Toast";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  updateCompanyRouterData,
  updateOtherRouterData,
} from "../../redux/companySlice";
import { clearRouterData, updateRouterData } from "../../redux/personSlice";
import { setBlockForm, setDcheck, setDname } from "../../redux/routerSlice";
import configureStore from "../../redux/store";
import InputText from "../other/InputText";
import KycSaveApiService from "../service/kycSaveApiService";
import {
  declerationValidation,
  validateSaveData,
  validateSubmitData,
} from "./dataValidataion";
import { PrevButton } from "./kycSidebar";
import ViewCompanyData from "./viewCompanyData";
import ViewFormData from "./viewFormData";
import { setErrorList } from "../../redux/lookupSlice";

import { useReactToPrint } from "react-to-print";
import apiService from "../service/apiService";
import { setRelativeTypeList } from "../../redux/familySlice";
import { setDocumentTypeList } from "../../redux/documentSlice";
import { englishLocales } from "validator/lib/alpha";
import DuplicateDialog from "./duplicateDialog";
import { offset } from "@popperjs/core";
import SecurityService from "../service/SecurityService";

function Decleration() {
  const { t } = useTranslation();
  const formType = useSelector((state) => state.routerData.formType);
  const dChecked = useSelector((state) => state.routerData.dChecked);
  const dName = useSelector((state) => state.routerData.dName);
  const dispatch = useDispatch();



  const relativeTypeList = useSelector(
    (state) => state.familyDetails.relativeTypeList
  );

  const documentTypeList = useSelector(
    (state) => state.documentDetails.documentTypeList
  );

  useEffect(() => {
    if (!relativeTypeList.length)
      apiService.getRelationTypeList().then((response) => {
        dispatch(setRelativeTypeList(response.data.data));
      });
    if (!documentTypeList.length)
      apiService.getDocumentTypeList().then((response) => {
        dispatch(setDocumentTypeList(response.data.data));
      });
  }, []);

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const [declerationNameError, setDeclerationNameError] = useState();
  const displayDeclerationErrorMessage = (val) => {
    const data = configureStore.getState();
    const name =
      formType === "I"
        ? data.personalDetails.firstName +
        " " +
        (data.personalDetails.middleName
          ? data.personalDetails.middleName + " "
          : "") +
        data.personalDetails.lastName
        : data.companyDetails.companyName;
    if (val !== name) {
      setDeclerationNameError("Name not matched with customer name");
    } else setDeclerationNameError("");
  };

  return (
    <Card
      style={{ borderRadius: "16px" }}
      className="p-col-12 p-md-12 main-card"
      header={
        <h3 className="p-col-12 p-md-12 text-center">
          <i className="pi pi-check-square" /> {t("declarationHeader")}
        </h3>
      }
      footer={() => (
        <div class=" p-field p-col-12 p-md-12">
          <div className="p-grid" style={{ flex: 3, padding: "0 10px" }}>
            <div style={{ flex: 1 }}>
              <PrevButton />
            </div>
            <div style={{ flex: 1 }}>
              <center>
                <SubmitButton style={{ flex: 1 }} />
              </center>
            </div>
            <div style={{ flex: 1 }}>
              <Button
                onClick={handlePrint}
                style={{ float: "right", justifyContent: "center", margin: 5 }}
              >
                Print
              </Button>

              {/* <iframe
                  id='ifmcontentstoprint'
                  style={{ height: 0, width: 0, position: 'absolute' }}
                ></iframe>
                <Button
                  onClick={() => printDiv('declarationPage')}
                  style={{ float: 'right', justifyContent: 'center' }}
                >
                  Print
                </Button> */}
            </div>
          </div>
        </div>
        // <div className="p-grid">
        //   <div className="p-col-12 p-md-5">
        //     <PrevButton />
        //   </div>
        //   <div className="p-col-12 p-md-3">
        //     <SubmitButton />
        //   </div>
        //   <div className="p-col-12 p-md-2"></div>
        //   <div className="p-col-12 p-md-2">
        //     <Button style={{ float: "right", marginRight: "15px" }}>
        //       Print
        //     </Button>
        //   </div>
        // </div>
      )}
    >
      <div className="p-grid p-fluid p-col-12 p-md-12" style={{ margin: 0 }}>
        <div id="declarationPage" ref={componentRef}>
          {formType === "I" ? <ViewFormData /> : <ViewCompanyData />}
        </div>

        <div className="p-field p-col-12 p-md-12 p-pl-0 p-pr-0">
          <div className="p-field p-col-12 p-md-12 ">
            <label
              className="p-col-12 p-md-12"
              htmlFor="decleration"
              style={{ textAlign: "center" }}
            >
              <Checkbox
                inputId="decleration"
                checked={dChecked}
                onChange={(e) => dispatch(setDcheck(e.checked))}
              />{" "}
              {t("declaration")}
            </label>
          </div>
        </div>
        <div className="p-field p-col-12 p-md-12 p-pl-0 p-pr-0">
          <div
            className="p-field p-col-12 p-md-12"
            style={{ textAlign: "center" }}
          >
            <label>{t("nameToConfirm")}</label>

            <InputText
              isName={formType === 'I'}
              clearSpace={formType === 'E'}
              // style={{textTransform:'uppercase'}}
              placeholder="Full Name"
              onChange={(e) => {
                dispatch(setDname(e.target.value));
                displayDeclerationErrorMessage(e.target.value);
              }}
            // onBlur={(e) => displayDeclerationErrorMessage(e.target.value)}
            />
          </div>
          <span style={{ color: "red" }}>{declerationNameError}</span>
        </div>
      </div>
    </Card>
  );
}

export const SaveButton = ({ onlySave, extraData, onReload }) => {
  const toast = useToast();
  const history = useHistory();
  const dispatch = useDispatch();
  const [rloading, setRloading] = useState(false);
  const { tempKycId, permKycId, status, customerId, formType } =
    useSelector((state) => state.routerData) || {};
  const sectionList = useSelector((state) => state.routerData.sectionList);

  const accept = () => {
    const data = configureStore.getState();
    if (validateSaveData(data, dispatch, toast, history, sectionList)) {
      setRloading(true);
      dispatch(setBlockForm(true));
      if (extraData) data.extraData = extraData;
      KycSaveApiService.savePersonalDetails(data)
        .then((response) => {
          if (formType === "C")
            dispatch(updateCompanyRouterData(response.data.data));
          else dispatch(updateRouterData(response.data.data));
          dispatch(updateOtherRouterData(response.data.data));
          setRloading(false);
          dispatch(setBlockForm(false));
          toast.success("Sucessful", "Sucessfully Submitted " + response.data.data.tempKycId)

          // window.location.reload();
        })
        .catch((e) => {
          setRloading(false);
          dispatch(setBlockForm(false));
          toast.error("Unsuccessful", e.response && e.response.data && (e.response.data.message || e.response.data.msg));
        });
      if (extraData == "instantAnalysis") onReload();
    }
  };

  const displayConfirmModal = () => {
    confirmDialog({
      message: "Are you sure you want to proceed?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept,
    });
  };

  const forwardToDashboard = (e) => {
    if (status) history.push("/kyc/dashboard");
    else {
      sessionStorage.clear();
      window.location.href = "/login";
    }
  };

  const displayExitModal = (e) => {
    confirmDialog({
      message: "Are you sure you want to Exit?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => forwardToDashboard(),
    });
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: "center",
      alignItems: "center"
    }}>
      <Button
        className="p-button-secondary button-save"
        label={extraData == "instantAnalysis" ? "Click to get BOIDS" : "Save"}
        icon={extraData == "instantAnalysis" ? "pi pi-fast-forward" : ""}
        loading={rloading}
        onClick={displayConfirmModal}
        style={{ margin: 5, flex: extraData == "instantAnalysis" ? 'none' : 1, width: extraData == "instantAnalysis" ? 220 : 'unset', }}
      />
      {onlySave || extraData == "instantAnalysis" ? null :
        <Button
          className="p-button-danger button-exit"
          label="Exit"
          style={{ margin: 5, flex: 1 }}
          // onClick={(e) => history.push("/kyc/dashboard")}
          onClick={displayExitModal}
        />}
    </div>
  );
};

export const SubmitButton = () => {
  const toast = useToast();
  const history = useHistory();
  const customerId = useSelector((state) => state.routerData.customerId);
  const dispatch = useDispatch();
  const [rloading, setRloading] = useState(false);
  const declarationStatus = declerationValidation(
    configureStore.getState(),
    dispatch,
    toast
  );
  const declarationName = useSelector(
    (state) => state.routerData.declarationName
  );
  const firstName = useSelector((state) => state.personalDetails.firstName);
  const middleName = useSelector((state) => state.personalDetails.middleName);
  const lastName = useSelector((state) => state.personalDetails.lastName);
  const companyName = useSelector((state) => state.companyDetails.companyName);
  const sectionList = useSelector((state) => state.routerData.sectionList);

  const [duplicateDialog, setDuplicateDialog] = useState(false);
  const [duplicateList, setDuplicateList] = useState({});
  const [errorCode, setErrorCode] = useState();
  const formType = useSelector((state) => state.routerData.formType);
  const duplicateData = useSelector((state) => state.routerData.duplicateData);

  const accept = () => {
    console.log("accept called");
    const data = configureStore.getState();
    if (validateSubmitData(data, dispatch, toast, history, sectionList)) {
      console.log("dataa is valid");
      setRloading(true);
      dispatch(setBlockForm(true));
      KycSaveApiService.submitPersonalDetails("F", data, null)
        .then((response) => {
          setRloading(false);
          dispatch(setBlockForm(false));
          toast.success("Sucessful", "Sucessfully Submitted " + (response &&
            response.data.data &&
            response.data.data.tempKycId));
          if (formType === "C")
            dispatch(updateCompanyRouterData(response.data.data));
          else dispatch(updateRouterData(response.data.data));
          dispatch(updateOtherRouterData(response.data.data));

          SecurityService.getRefreshToken()
            .then((response) => {
              if (response.data.jti) {
                sessionStorage.setItem("token", response.data.jti);
                sessionStorage.setItem("access_token", response.data.jti);
                sessionStorage.setItem("refresh_token", response.data.jti);
                sessionStorage.setItem("expires_in", eval(Date.now()));
                window.location.href = "/kyc/dashboard";
              } else {
                toast.error("Error Message", "Error. Please Login!!!");
                window.location.href = "/login";
              }
            })
            .catch((error) => {
              toast.error("Error Message", error.response && error.response.data && error.response.data.msg);

              window.location.href = "/login";
            });

        })
        .catch((error) => {
          console.log("errorrroror", error.response)
          setRloading(false);
          dispatch(setBlockForm(false));
          var nList = [];
          if (error.response.data) {
            for (var key in error.response.data) {
              console.log(error.response.data[key].message);
              const section = sectionList.find(
                (s) => s.code === error.response.data[key].section
              );
              nList.push({
                section,
                msg: error.response.data[key].message,
              });
            }
            dispatch(setErrorList(nList));
          }
          if (error && error.response && error.response.data && error.response.data.msg && error.response.data.msg.includes("duplicate_data_issue")) {
            toast.error("Unsuccessful", error.response && error.response.data && (error.response.data.message || error.response.data.msg));
            return;
          }
          if (error && error.response && error.response.data && error.response.data.msg.includes("duplicate_data_")) {
            setDuplicateDialog(true);
            setDuplicateList(error.response.data.data);
            setErrorCode(error.response.data.msg)
          } else
            toast.error("Unsuccessful", error.response && error.response.data && (error.response.data.message || error.response.data.msg));

        });

      // KycSaveApiService.savePersonalDetails(data)
      //   .then((response) => {



      //   })
      //   .catch((error) => {
      //     setRloading(false);
      //     dispatch(setBlockForm(false));
      //     toast.error("Unsuccessful", error.response && error.response.data && (error.response.data.message || error.response.data.msg));

      //   });
    } else {
      setTimeout(
        () =>
          document.getElementById("errorDiv") &&
          document.getElementById("errorDiv").scrollIntoView(),
        1000
      );
    }
  };

  const displayConfirmModal = async () => {
    if (Array.isArray(duplicateData) && duplicateData.length != 0) {
      await confirmDialog({
        message: "Do you want to add 100% match duplicate BOID?",
        header: "Confirmation",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          // Do nothing, continue as normal
          console.log("Accepted: Continue process");
          history.push("/kyc/boid");
          // window.location.href = "boid";
        }, reject: () => {
          confirmDialog({
            message: "Are you sure you want to Submit?",
            header: "Confirmation",
            icon: "pi pi-exclamation-triangle",
            accept,
          });
          // Redirect to another page
        },
      });
    }
    else
      await confirmDialog({
        message: "Are you sure you want to Submit?",
        header: "Confirmation",
        icon: "pi pi-exclamation-triangle",
        accept,
      });
  };

  const forwardToDashboard = (e) => {
    history.push("/kyc/dashboard");
  };

  const displayExitModal = (e) => {
    confirmDialog({
      message: "Are you sure you want to Exit?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => forwardToDashboard(),
    });
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: "center",
      alignItems: "center"
    }}>

      <Button
        className="p-button-success"
        label="Submit"
        loading={rloading}
        iconPos="right"
        disabled={!declarationStatus}
        onClick={displayConfirmModal}
        style={{ margin: 5, flex: 1 }}
      />
      <Button
        className="p-button-danger"
        label="Exit"
        style={{ margin: 5, flex: 1 }}
        // onClick={(e) => history.push("/kyc/dashboard")}
        onClick={displayExitModal}
      />
      {duplicateDialog && (
        <DuplicateDialog
          visible={duplicateDialog}
          onHide={() => setDuplicateDialog(false)}
          duplicateList={duplicateList}
          errorCode={errorCode}
        />
      )}
    </div>
  );
};

export const printDiv = (id) => {
  var content = document.getElementById(id);
  var pri = document.getElementById("ifmcontentstoprint").contentWindow;
  pri.document.open();
  pri.document.write(content.innerHTML);
  pri.document.close();
  pri.focus();
  pri.print();
};

export default Decleration;
